export enum StorageSubTechnology {
  CONTAINER_BASED = 'CONTAINER_BASED',
  BUILDING_BASED = 'BUILDING_BASED',
}
export const storageSubTechnologyToLabel = {
  [StorageSubTechnology.CONTAINER_BASED]: 'Ground Based - Container',
  [StorageSubTechnology.BUILDING_BASED]: 'Ground Based - Building',
};
